module.exports = __webpack_public_path__ + "static/media/wizualizacja-10.93cbdefe.png";